import NavImmersive from '../nav-main/src/v2/nav-immersive';

/* istanbul ignore next */
NavImmersive.install = function(Vue) {
  Vue.component(NavImmersive.name, NavImmersive);
};

export default NavImmersive;
